const APP_SCRIPT_PATTERN = /\/js\/app(?:\.[a-z0-9-]+)?\.js$/i

const findAppScriptPath = (root, baseUrl) => {
  const scripts = Array.from(root.querySelectorAll('script[src]'))
  for (const script of scripts) {
    try {
      const url = new URL(script.getAttribute('src'), baseUrl)
      if (APP_SCRIPT_PATTERN.test(url.pathname)) return url.pathname
    } catch (_) {
      // Ignore malformed third-party script URLs.
    }
  }
  return ''
}

export const refreshStaleBuild = async () => {
  if (process.env.NODE_ENV !== 'production') return false

  try {
    const currentBuild = findAppScriptPath(document, window.location.href)
    if (!currentBuild) return false

    const indexUrl = new URL(process.env.BASE_URL, window.location.origin)
    indexUrl.searchParams.set('__shareai_check', Date.now().toString(36))

    const response = await fetch(indexUrl.href, {
      cache: 'no-store',
      credentials: 'same-origin'
    })
    if (!response.ok) return false

    const freshDocument = new DOMParser().parseFromString(await response.text(), 'text/html')
    const freshBuild = findAppScriptPath(freshDocument, indexUrl.href)
    if (!freshBuild || freshBuild === currentBuild) return false

    // One reload per target build avoids a loop if an intermediary ignores no-store and query strings.
    const reloadUrl = new URL(window.location.href)
    if (reloadUrl.searchParams.get('__shareai_reload') === freshBuild) return false

    reloadUrl.searchParams.set('__shareai_reload', freshBuild)
    window.location.replace(reloadUrl.href)
    return true
  } catch (_) {
    // Version checks are best-effort and must never stop the application from mounting.
    return false
  }
}
